import React from 'react';
import { StyledAlert, ErrorMessage } from './styled';

const renderErrorMessages = (errors) =>
  errors.map(({ errorMessage }) => <ErrorMessage key={errorMessage}> {errorMessage} </ErrorMessage>);

const ValidationErrors = ({ errors }) => {
  if (!errors?.length) return null;

  return <StyledAlert type="error" message={renderErrorMessages(errors)} />;
};

export default ValidationErrors;
